<template>
  <v-app id="inspire">
    <v-navigation-drawer v-model="drawer" app>
      <Menu />
    </v-navigation-drawer>

    <v-app-bar app color="primary" dark>
      <v-app-bar-nav-icon @click.stop="drawer = !drawer"></v-app-bar-nav-icon>
      <img
        src="/logo.png"
        height="25"
        class="mr-5 pointer"
        @click="$router.push('/')"
      />
      <v-toolbar-title class="pointer" @click="$router.push('/')"
        >Карта Воды</v-toolbar-title
      >
      <v-spacer></v-spacer>
      <v-btn
        class="hidden-sm-and-down"
        text
        @click="$router.push({ name: 'user-settings' })"
      >
        <v-icon>mdi-account</v-icon> {{ currentUser.name }}
      </v-btn>
      <v-btn class="hidden-sm-and-down" text icon @click="logout()">
        <v-icon>mdi-logout-variant</v-icon>
      </v-btn>
    </v-app-bar>

    <v-main>
      <v-container fluid style="padding-bottom: 70px;">
        <slot></slot>
      </v-container>
    </v-main>
  </v-app>
</template>

<script>
import Menu from "../components/Menu";
import store from "../store";
import axios from "axios";
import api from "../api";

export default {
  name: "default-layout",
  components: {
    Menu
  },
  data: function() {
    return {
      drawer: false
    };
  },
  computed: {
    currentUser() {
      return store.currentUser;
    }
  },
  methods: {
    logout() {
      // удаляем всю инфу о юзере
      store.currentUser = {};
      axios.defaults.headers.common["X-token"] = "";
      localStorage.removeItem("token");
      // переадресовываем на страницу авторизации
      this.$router.push({ name: "login" });
    }
  },
  mounted() {
    // забираем id пользователя из хранилища
    const userId = localStorage.getItem("user-id");
    if (userId) {
      axios.get(api.usersettings).then(resp => {
        store.currentUser = resp.data;
      });
    }
  }
};
</script>

<style>
.pointer {
  cursor: pointer;
}
</style>
